import React from "react";

import { Box, Link, Typography, Card, CardContent } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from '@mui/styles';
import clsx from "clsx";

// common
import { dic } from "@common/text_defs";
// component
import ImgSvcSystemDev from "@imgs/svc-system-dev.png";
import ImgSvcAlgorithms from "@imgs/svc-algorithms.png";
import ImgSvcDataHubX from "@imgs/svc-data-hub-x.png";
import ImgSvcStrgyDev from "@imgs/svc-strgy-dev.png";

const useStyles = makeStyles(({ palette }: any) => ({
  card: {
    borderTop: "2px solid black",
    "& .icon": {
      fontSize: 64,
    },

    "&:hover": {
      borderTop: "2px solid rgba(var(--primary), 1)",
      "& .icon": {
        color: "rgba(var(--primary),1)",
      },
    },
  },
}));

const ServicesSection = () => {
  const classes = useStyles();

  const serviceList = [
    {
      icon: (ImgSvcSystemDev),
      title: dic.services.system_dev.title,
      text: dic.services.system_dev.desc,
      link: '/svc_maint_support',
    },
    {
      icon: (ImgSvcAlgorithms),
      title: dic.services.algorithms.title,
      text: dic.services.algorithms.desc,
      link: '/svc_algorithm',
    },
    {
      icon: (ImgSvcDataHubX),
      title: dic.services.data_hub.title,
      text: dic.services.data_hub.desc,
      link: '/svc_data_hub',
    },
    {
      icon: (ImgSvcStrgyDev),
      title: dic.services.power_system.title,
      text: dic.services.power_system.desc,
    },
  ];

  return (
    <section className="section" id="service">
      <div className="container">
        <div className="section__header">
          <h2>{dic.services.main_title}</h2>
          <p>
            {dic.services.sub_title}
          </p>
        </div>

        <Grid container spacing={3} alignContent="stretch">
          {serviceList.map((service) => (
            <Grid md={3} sm={6} key={service.title}>
              <Card className={clsx("card h-full", classes.card)} >
                <CardContent sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between !important", minHeight: "100% !important" }}>
                  <Link href={service.link}>
                    <Box sx={{ flexGrow: "1", textAlign: 'center' }}>
                      <Box component="img" className="text-center mb-4" src={service.icon} sx={{ textAlign: 'center', height: 64, }} />
                      <h3 className="font-light text-24">{service.title}</h3>
                      <Typography sx={{ textAlign: 'left' }}>
                        {service.text}
                      </Typography>
                    </Box>
                  </Link>
                  <Box sx={{ pt: 4 }}>
                    <Link href={service.link}>READ MORE</Link>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export { ServicesSection };
